import { render, staticRenderFns } from "./NotArrivedOrders.vue?vue&type=template&id=5ffe8117&"
import script from "./NotArrivedOrders.vue?vue&type=script&lang=js&"
export * from "./NotArrivedOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NotArrivedOrders.vue"
export default component.exports